<template v-model="visible" v-if="visible">
  <div class="d3 hd">
    <!-- <h2 class="cap2_xm">{{ title }}</h2> -->
  </div>
  <div class="d bar back_left" @click="goBack">
    <p :class="`a_back ${isForm == 1 ? 'p_b' : ''}`">
      <van-icon name="arrow-left" color="#fff" size="28" />
      <!-- <van-image width="100" height="100" src="../assets/images/i_back2.png" /> -->
    </p>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: "少先队组织信息数据系统",
    },

    goBack: {
      type: Function,
    },
    isForm: {
      type: Number,
      default: 0
    }
  },
  setup() {},
};
</script>
<style lang="less" scoped>
.back_left {
  width: 10%;
  height: 0.883rem;
  position: absolute;
  top: 0.233rem;
  left: 0.133rem;
  z-index: 99;
}
.go_back {
  height: 0.383rem;
  padding: 0.033rem 0 0 0.333rem;
  overflow: visible;
  color: rgb(255, 255, 255);
  font-size: 28px;
  z-index: 99;
}
.p_b {
  background: rgba(255, 255, 255, 0.8);
  border: 1px solid #fff;
  border-radius: 3px;
  display: flex;
  justify-content: center;
  i {
    color: #ff6865 !important;
  }
}
</style>
